const pad = (n: number) => n.toString().padStart(2, '0');

const multipliers = {
  days: 86400,
  hours: 3600,
  minutes: 60,
  seconds: 1,
} as const;

export type TimeUnit = keyof typeof multipliers;

export default function toDuration(value: number, unit: TimeUnit = 'hours') {
  const totalSeconds = Math.round(value * multipliers[unit]);

  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = totalSeconds % 60;

  return `${pad(h)}:${pad(m)}:${pad(s)}`;
}
